import { render, staticRenderFns } from "./PurchaseOrderMainButtons.vue?vue&type=template&id=5d512979&scoped=true&"
import script from "./PurchaseOrderMainButtons.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderMainButtons.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseOrderMainButtons.vue?vue&type=style&index=0&id=5d512979&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d512979",
  null
  
)

export default component.exports